import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { WorkspacesService } from 'src/app/sections/workspaces/services/workspaces.service';

/**
 * Restricts access to workspace-owner-only routes.
 */
export const WorkspaceOwnerGuard: CanActivateFn = async (route) => {
  const auth = inject(Auth);
  const workspacesService = inject(WorkspacesService);
  const router = inject(Router);

  const user = await firstValueFrom(authState(auth).pipe(take(1)));

  let workspaceId = route.paramMap.get('workspaceId');
  let parent = route.parent;
  while (!workspaceId && parent) {
    workspaceId = parent.paramMap.get('workspaceId');
    parent = parent.parent;
  }

  if (!user || !workspaceId) {
    router.navigate(['/workspaces']);
    return false;
  }

  try {
    const workspace = await firstValueFrom(workspacesService.getWorkspaceDoc$(workspaceId).pipe(take(1)));

    if (!workspace) {
      router.navigate(['/workspaces']);
      return false;
    }

    if (workspace.current_owner_id !== user.uid) {
      router.navigate(['/workspace', workspaceId, 'manage', 'workspace']);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error checking workspace ownership:', error);
    router.navigate(['/workspaces']);
    return false;
  }
};
